import axios from "@/plugins/axios.js";
import store from "@/store";
// states
export const state = {
  validation: {
    minOrderAmount: {
      status: false,
      message: "",
    },
    userInfo: {
      status: false,
      message: "",
    },
    deliveryInfo: {
      status: false,
      message: "",
    },
    deliveryWhen: {
      status: false,
      message: "",
    },
    paymentInfo: {
      status: false,
      message: "",
    },
    promoCode: {
      status: null,
      message: "",
    },
  },
  deliveryServices: [],
  paymentOptions: [],
  paymentType: null,
  comment: null,
  offer: null,
  total: 0,
  cardInputElement: null,
  useCredit: false,
  flatPayCheckoutData: {
    paymentType: null,
    fp_id: null,
    url: null,
    checkoutData: null,
  },
  isNewFlatPayMethod: false,
};

// mutations
export const mutations = {
  SET_VALIDATION_MIN_ORDER_AMOUNT: (state, data) => {
    state.validation.minOrderAmount = data;
  },
  SET_VALIDATION_USER_INFO: (state, data) => {
    state.validation.userInfo = data;
  },
  SET_VALIDATION_DELIVERY_INFO: (state, data) => {
    state.validation.deliveryInfo = data;
  },
  SET_VALIDATION_DELIVERY_WHEN: (state, data) => {
    state.validation.deliveryWhen = data;
  },
  SET_VALIDATION_PAYMENT_INFO: (state, data) => {
    state.validation.paymentInfo = data;
  },
  SET_VALIDATION_PROMO_CODE: (state, data) => {
    state.validation.promoCode.status = data.status;
    state.validation.promoCode.message = data.message;
  },
  SET_DELIVERY_SERVICES: (state, data) => {
    state.deliveryServices = data;
  },
  SET_PAYMENT_OPTIONS: (state, data) => {
    state.paymentOptions = data;
  },
  SET_PAYMENT_TYPE: (state, data) => {
    state.paymentType = data;
  },
  SET_COMMENT: (state, data) => {
    state.comment = data;
  },
  SET_OFFER: (state, data) => {
    state.offer = data;
  },
  SET_TOTAL: (state, data) => {
    state.total = data;
  },
  SET_CARD_INPUT_ELEMENT: (state, data) => {
    state.cardInputElement = data;
  },
  SET_USE_CREDIT: (state, data) => {
    state.useCredit = data;
  },
  SET_FLAT_PAY_CHECKOUT_DATA: (state, data) => {
    state.flatPayCheckoutData = data;
  },
  SET_FLAT_PAY_ADD_METHOD: (state, data) => {
    state.isNewFlatPayMethod = data;
  },
};

// actions
export const actions = {
  setValidationMinOrderAmount({ commit }, payload) {
    commit("SET_VALIDATION_MIN_ORDER_AMOUNT", payload);
  },
  setValidationUserInfo({ commit }, payload) {
    commit("SET_VALIDATION_USER_INFO", payload);
  },
  setValidationDeliveryInfo({ commit }, payload) {
    commit("SET_VALIDATION_DELIVERY_INFO", payload);
  },
  setValidationDeliveryWhen({ commit }, payload) {
    commit("SET_VALIDATION_DELIVERY_WHEN", payload);
  },
  setValidationPaymentInfo({ commit }, payload) {
    commit("SET_VALIDATION_PAYMENT_INFO", payload);
  },
  //

  setValidationPromoCode({ commit }, payload) {
    commit("SET_VALIDATION_PROMO_CODE", payload);
  },
  setFlatPayCheckoutData({ commit }, payload) {
    commit("SET_FLAT_PAY_CHECKOUT_DATA", payload);
  },
  setAddFlatPayMethod({ commit }, payload) {
    commit("SET_FLAT_PAY_ADD_METHOD", payload);
  },
  async loadDeliveryServices({ commit }) {
    store.dispatch("loading/start");
    const { data } = await axios.get("/app/services");
    let services = [];
    if (store.getters.storeInfo.configs.supportDelivery) {
      services.push(
        _.find(data.data, {
          serviceName: "Delivery",
        })
      );
    }
    if (store.getters.storeInfo.configs.supportPickup) {
      services.push(
        _.find(data.data, {
          serviceName: "Pickup",
        })
      );
    }
    commit("SET_DELIVERY_SERVICES", services);
    store.dispatch("loading/done");
  },
  async loadPaymentOptions({ commit }) {
    store.dispatch("loading/start");
    const { data } = await axios.get("/app/orders/paymentTypes", {
      params: {
        storeId: store.getters.storeInfo.id,
        serviceSlug: store.getters.deliveryMethod,
      },
    });
    commit("SET_PAYMENT_OPTIONS", data.data);
    store.dispatch("loading/done");
  },
  setPaymentType({ commit }, payload) {
    commit("SET_PAYMENT_TYPE", payload);
  },
  setComment({ commit }, payload) {
    commit("SET_COMMENT", payload);
  },
  setOffer({ commit }, payload) {
    commit("SET_OFFER", payload);
  },
  setTotal({ commit }, payload) {
    commit("SET_TOTAL", payload);
  },
  setCardInputElement({ commit }, payload) {
    commit("SET_CARD_INPUT_ELEMENT", payload);
  },
  setUseCredit({ commit }, payload) {
    commit("SET_USE_CREDIT", payload);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
